/*
*  geolocation-simulator.js v0.0.1
*  (c) 2014, Russell Goldenberg
*  MIT License
*/

(function($) {
    function get_random_accuracy() {
        return (Math.random()*80)+1;
    }
    //constants
    var KM_IN_DEGREE = 110.562,
        SECONDS_IN_HOUR = 3600,
        UPDATE_INTERVAL = 1000;
    
    $.GeoSim = function(params) {
        var self = {};
        //private vars
        var _watchTimer = null,
            // _coords = params.coords,
            _speed = (params.speed || 40) / SECONDS_IN_HOUR, // km/second (defaults to 40kmh or 25mph)
            _current = { 
                coords: { 
                    latitude: 0,
                    longitude: 0,
                    accuracy: get_random_accuracy(),
                    altitude: null,
                    altitudeAccuracy: null,
                    heading: null,
                    speed: null
                },
                timestamp: 1},
            _rate = {latitude: 0, longitude: 0},
            _index = -1,
            _pauseTimeout,
            _numSteps,
            _currentStep,
            _tracker = params.tracker,
            _repeat = params.repeat || false;
            
        var _onsimulationfinished = params.onsimulationfinished || function() {};
        var _show_route = false;
        var _addGPSRouteCallback = function(evt) { 
            self.updateViewportHandler.call(self, evt);
        };

        self.updateViewportHandler = function(evt) {
            var viewer = evt.eventSource;
            var pixelDensityRatio = OpenSeadragon.pixelDensityRatio;
            if (typeof(viewer.abdo) !== "undefined" && typeof(viewer.abdo.localization) !== "undefined") {
                var localization = viewer.abdo.localization;
                var i;
                for(i = 1; i < _tracker.gps_simulator.current_coordinates.length; i++) {
                    var prev = _tracker.gps_simulator.current_coordinates[i-1];
                    var current = _tracker.gps_simulator.current_coordinates[i];
                    var prev_pt_xy = localization.lonlat2vp(prev.longitude, prev.latitude);
                    var current_pt_xy = localization.lonlat2vp(current.longitude, current.latitude);
    
                    var prev_pt = new OpenSeadragon.Point(prev_pt_xy[0], prev_pt_xy[1]);
                    var current_pt = new OpenSeadragon.Point(current_pt_xy[0], current_pt_xy[1]);
    
                    var prev_pt_canvas    = viewer.viewport.pixelFromPoint(prev_pt);
                    var current_pt_canvas = viewer.viewport.pixelFromPoint(current_pt);
                    var ctx = viewer.drawer.context;
                    // draw line
                    ctx.beginPath();
                    ctx.lineWidth = 5 * pixelDensityRatio;
                    ctx.shadowBlur = 6 * pixelDensityRatio;
                    ctx.shadowOffsetX = 6 * pixelDensityRatio;
                    ctx.shadowOffsetY = 6 * pixelDensityRatio;
                    ctx.moveTo(prev_pt_canvas.x * pixelDensityRatio, prev_pt_canvas.y * pixelDensityRatio);
                    ctx.lineTo(current_pt_canvas.x * pixelDensityRatio, current_pt_canvas.y * pixelDensityRatio);
                    ctx.stroke();
                }
            }
           
        };
        

        self.showGPSRoute = function() {
            if (typeof(_tracker) !== 'undefined') {
                var i;
                for (i = 0; i < _tracker.viewers.length; i++) {
                    var viewer = _tracker.viewers[i];
                    viewer.addHandler('update-viewport', _addGPSRouteCallback);
                    viewer.world.draw();
                    viewer.raiseEvent('update-viewport', viewer);
                    _show_route = true; 
                    
                }
            } 
           
        };

        self.hideGPSRoute = function() {
            if (typeof(_tracker) !== 'undefined') {
                var i;
                for (i = 0; i < _tracker.viewers.length; i++) {
                    var viewer = _tracker.viewers[i];
                    viewer.removeHandler('update-viewport', _addGPSRouteCallback);
                    viewer.world.draw();
                    viewer.raiseEvent('update-viewport', viewer);
                    _show_route = false;
                }
            }
        };
        
        self.toggleGPSRoute = function() {
            if (_show_route) {
                self.hideGPSRoute();
            }
            else {
                self.showGPSRoute();
            }
        };


        //public functions            
        self.start = function() {
            // do nothing if no simulation data is given
            if (_tracker.gps_simulator.current_coordinates.length == 0) {
                console.error("No GPS simulation data");
            }
            else { 
                self.overrideEvents();
                nextCoord();
                return true;
            }
            
            return false;
        };

        self.restore = function() {
            if (_tracker.gps_simulator.current_coordinates.length > 0) {
                clearTimeout(_currentTimer);
                navigator.geolocation.clearWatch(_watchTimer);
                self.hideGPSRoute();
    
                navigator.geolocation.getCurrentPosition = self._OriginalGetCurrentPosition;
                navigator.geolocation.watchPosition = self._OriginalWatchPosition;
                navigator.geolocation.clearWatch = self._OriginalClearWatch;
            }
            else {
                console.error("No GPS data was present at the time of calling restore()");
            }
        };

        self.overrideEvents = function() {
            //override native geolocation   
            navigator.geolocation.getCurrentPosition = function(cb, error, options) {
                cb(_current);
            };
            navigator.geolocation.watchPosition = function(cb, error, options) { 
                var sendPos = function() {
                    cb(_current); 
                };
    
                sendPos();
                _watchTimer = setInterval(sendPos, 1000);
                return _watchTimer;
            }; 
            navigator.geolocation.clearWatch = function() {
                clearTimeout(_watchTimer);
            };
        };

 
        //private functions

        //advance to next coordinate in array
        function nextCoord() { 
            _index++;
            //check if route completed
            if(_index < _tracker.gps_simulator.current_coordinates.length - 1) {
                var coord = _tracker.gps_simulator.current_coordinates[_index];
                
                //set current coordinate, to make sure it makes the jump
                _current.coords.latitude = coord.latitude;
                _current.coords.longitude = coord.longitude;
                _current.coords.accuracy = get_random_accuracy();
                //set rate of change
                //distance between points with direction for lat and lon (km)
                var deltaLat = (_tracker.gps_simulator.current_coordinates[_index+1].latitude - coord.latitude) * KM_IN_DEGREE,
                    deltaLon = (_tracker.gps_simulator.current_coordinates[_index+1].longitude - coord.longitude) * KM_IN_DEGREE;
                
                //as the crow flies distance (km)
                var deltaDist = Math.sqrt((deltaLat * deltaLat) + (deltaLon * deltaLon));
                
                //total time between points at desired speed (sec)
                var deltaSeconds = Math.floor(deltaDist / _speed);

                //rate of change for each update (1 sec) in lat/lon
                _rate.latitude = deltaLat / deltaSeconds / KM_IN_DEGREE;
                _rate.longitude = deltaLon / deltaSeconds / KM_IN_DEGREE;

                //total steps aka number of seconds
                _numSteps = deltaSeconds;
                _currentStep = 0;

                //check for pause request
                if(coord.pause) {
                    console.log('(pausing for ', Math.floor(coord.pause / 1000) , 'seconds)');
                    _pauseTimeout = setTimeout(step, coord.pause);
                } else {
                    //proceed at regular interval
                    _currentTimer = setTimeout(step, UPDATE_INTERVAL);
                }
            } else { 
                //path is complete
                if (!_repeat) {
                    ABDOUtil.display_message('到着しました', 5000);
                    // alert('到着しました');
                    self.restore(); 
                    _onsimulationfinished();
                }
                else {
                    _index = -1;
                    _currentStep = 0;
                    nextCoord();
                }   
            }
        }

        //advance to next update along path between points
        function step() {
            _currentStep++;
            if(_currentStep < _numSteps) {
                _current.coords.latitude += _rate.latitude;
                _current.coords.longitude += _rate.longitude;
                _current.coords.accuracy = get_random_accuracy();
                setTimeout(step, UPDATE_INTERVAL);
            } else {
                nextCoord();
            }
        }

        //override native geolocation
        self._OriginalGetCurrentPosition = navigator.geolocation.getCurrentPosition; 
        self._OriginalWatchPosition = navigator.geolocation.watchPosition;
        self._OriginalClearWatch = navigator.geolocation.clearWatch; 
        

        return self;
    };

    // window.GeolocationSimulator = GeoSim;
})(ABDOMap);